// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html, body {\n  margin: 0px;\n  padding: 0px;\n}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA;EAEE,WAAA;EAAa,YAAA;AACf","file":"styles.scss","sourcesContent":["html, body\n{\n  margin: 0px; padding: 0px\n}\n\n"]}]);
// Exports
module.exports = exports;
